import { Wrapper } from '@googlemaps/react-wrapper'
import { memo, useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import { FilterBanner, FilterBannerSlim } from './FilterBanner'
import { useTranslation } from 'react-i18next'

const defaultFilterStack = JSON.stringify({
  filterStack: [
    { selection: '', title: 'CATEGORIES', filteredObjectProperty: 'StockistOrReseller', inputType: 'radio', comparator: 'eq' },
    { selection: '', title: 'STATE', filteredObjectProperty: 'PhysicalState', inputType: 'radio', comparator: 'eq' },
    { selection: '', title: 'DISPLAY', filteredObjectProperty: 'HasDisplay', inputType: 'radio', comparator: 'eq' },
  ],
})

const isJson = (str) => {
  try{
     JSON.parse(str);
  }catch (e){
     //Error
     //JSON is not okay
     return false;
  }

 return true;
}

const WhereToBuyLocation = props => {
  let { relatedCollectionDataList, wtbFilters = defaultFilterStack, wtbMapConfiguration, wtbLayoutType = 'full', showSearch = true, contentElementName = "" } = props
  const [searchValue, setSearchValue] = useState('')
  const [filterStack, setFilterStack] = useState(isJson(wtbFilters)?JSON.parse(wtbFilters)?.filterStack:[])
  const [displayedRetailLocations, setDisplayedRetailLocations] = useState(
    relatedCollectionDataList
      ?.sort((a, b) => a.CustomerName.localeCompare(b.CustomerName))
      .map(rtl => {
        rtl.searchHash = Object.values(rtl)
          .filter(e => `${e}`?.trim()?.length)
          .join('|')
          .toLocaleLowerCase()
        rtl.active = true
        return rtl
      })
  )

  const theme = useSelector((state) => state.configuration.site.theme);
  if(!wtbMapConfiguration) wtbMapConfiguration = JSON.stringify(theme.mapsBaseConfig ? theme.mapsBaseConfig : "") //Set the default config is not is provided

  // change cetner of map when a RetailLocation is clicked //JSON.parse(wtbMapConfiguration)?.mapCenter
  const [mapCenter, setMapCenter] = useState(JSON.parse(wtbMapConfiguration)?.mapCenter)
  const [defaultZoom] = useState(JSON.parse(wtbMapConfiguration)?.defaultZoom)

  const updateFiltersAndLocations = (key, selection, searchText = searchValue) => {
    setSearchValue(searchText)
    setFilterStack(filters => {
      return filters.map(filter => {
        if (filter.title === key) {
          filter.selection = selection
        }
        return filter
      })
    })

    const requiredFilterStack = filterStack
      .map(filter => {
        if (filter.title === key) {
          filter.selection = selection
        }
        return filter
      })
      .filter(el => el.selection.length > 0)

    setDisplayedRetailLocations(locs =>
      locs.map(retailLoc => {
        retailLoc.active =
          requiredFilterStack.filter(filterEl => {
            return retailLoc[filterEl.filteredObjectProperty]?.trim() === filterEl.selection
          }).length === requiredFilterStack.length && (searchText.length > 0 ? retailLoc.searchHash?.includes(searchText?.toLowerCase()) : true)
        return retailLoc
      })
    )
  }

  if (wtbLayoutType === 'slimRow') { 
    return <WhereToBuyLocationSlim displayedRetailLocations={displayedRetailLocations} updateFiltersAndLocations={updateFiltersAndLocations} filterStack={filterStack} mapCenter={mapCenter} defaultZoom={defaultZoom} setMapCenter={setMapCenter} setDisplayedRetailLocations={setDisplayedRetailLocations} searchValue={searchValue} setSearchValue={setSearchValue} showSearch={showSearch} title={contentElementName}/>
  }else{
    return <WhereToBuyLocationFull displayedRetailLocations={displayedRetailLocations} updateFiltersAndLocations={updateFiltersAndLocations} filterStack={filterStack} mapCenter={mapCenter} defaultZoom={defaultZoom} setMapCenter={setMapCenter} setDisplayedRetailLocations={setDisplayedRetailLocations} searchValue={searchValue} setSearchValue={setSearchValue}  showSearch={showSearch} title={contentElementName}/>
  }
}

const WhereToBuyLocationFull = ({ displayedRetailLocations, updateFiltersAndLocations, filterStack, mapCenter, defaultZoom, setMapCenter, setDisplayedRetailLocations, searchValue, setSearchValue, showSearch, title}) => {
  const hasResults = displayedRetailLocations.filter(loc => loc.active).length > 0
  console.log(displayedRetailLocations)
  return (
    <div className="container">
       {title ? <h2 className="text-center" >{title}</h2> : null} 
      <div className="container-fluid">
        <div className="grid py-3">
          {(showSearch || filterStack) && (
            <div className="g-col-12 g-col-md-4 g-col-lg-3">
              <FilterBanner updateFiltersAndLocations={updateFiltersAndLocations} data={displayedRetailLocations} filters={filterStack} searchValue={searchValue} setSearchValue={setSearchValue} showSearch={showSearch} />
            </div>
          )}
          <div className={`${showSearch || filterStack ? 'g-col-12 g-col-md-8 g-col-lg-9' : 'g-col-12'}`} >
            <GoogleMap
              AddressLatitude={mapCenter?.AddressLatitude}
              AddressLongitude={mapCenter?.AddressLongitude}
              zoom={defaultZoom}
              locations={displayedRetailLocations
                .filter(loc => loc.active)
                .map(loc => {
                  return { ...loc, AddressLatitude: parseFloat(loc.AddressLatitude), AddressLongitude: parseFloat(loc.AddressLongitude) }
                })}
            />
          </div>
        </div>
      </div>
      {!hasResults && <p className="text-center bg-white rounded p-2">No locations were found with the given criteria. Please modify your selections or input.</p>}

      <div
        className="grid py-5"
        onClick={e => {
          e.preventDefault()
          const addressLatitude = e.target.closest('.retailLoc').getAttribute('data-addresslatitude')
          const addresslongitude = e.target.closest('.retailLoc').getAttribute('data-addresslongitude')
          setMapCenter({ AddressLatitude: parseFloat(addressLatitude), AddressLongitude: parseFloat(addresslongitude) })
          const requiredFilterStack = filterStack?.filter(el => el.selection.length > 0)
          setDisplayedRetailLocations(locs =>
            locs.map(retailLoc => {
              retailLoc.active =
                requiredFilterStack?.filter(filterEl => {
                  return retailLoc[filterEl.filteredObjectProperty]?.trim() === filterEl.selection
                }).length === requiredFilterStack.length && (searchValue.length > 0 ? retailLoc.searchHash?.includes(searchValue?.toLowerCase()) : true)
              return retailLoc
            })
          )
        }}
      >
        {displayedRetailLocations?.map(loc => {
          return <RetailLocation key={loc.CustomerName} {...loc} />
        })}
      </div>
    </div>
  )
}

const WhereToBuyLocationSlim = ({ displayedRetailLocations, updateFiltersAndLocations, filterStack, mapCenter, defaultZoom, setMapCenter, setDisplayedRetailLocations, searchValue, setSearchValue, showSearch, title }) => {
  const hasResults = displayedRetailLocations.filter(loc => loc.active).length > 0
  return (
    <div className="WhereToBuyLocationSlim p-3">
      {title ? <h2 className="text-center" >{title}</h2> : null} 
      <div className="container-fluid">
        {(showSearch || filterStack) && (
          <div className=" py-3">
            <FilterBannerSlim updateFiltersAndLocations={updateFiltersAndLocations} data={displayedRetailLocations} filters={filterStack} searchValue={searchValue} setSearchValue={setSearchValue} showSearch={showSearch} />
          </div>
        )}
        <div className="grid py-3">
          <div className="g-col-12 g-col-md-8 ">
            <GoogleMap
              AddressLatitude={mapCenter?.AddressLatitude}
              AddressLongitude={mapCenter?.AddressLongitude}
              zoom={defaultZoom}
              locations={displayedRetailLocations
                .filter(loc => loc.active)
                .map(loc => {
                  return { ...loc, AddressLatitude: parseFloat(loc.AddressLatitude), AddressLongitude: parseFloat(loc.AddressLongitude) }
                })}
            />
          </div>
          <div className="g-col-12 g-col-md-4">
            {!hasResults && <p className="text-center bg-white rounded p-2">No locations were found with the given criteria. Please modify your selections or input.</p>}

            <div
              className="grid pe-3"
              style={{ maxHeight: '500px', overflowY: 'auto' }}
              onClick={e => {
                e.preventDefault()
                const addressLatitude = e.target?.closest('.retailLoc')?.getAttribute('data-addresslatitude')
                const addresslongitude = e.target?.closest('.retailLoc')?.getAttribute('data-addresslongitude')
                if (addressLatitude?.length > 0 && addresslongitude?.length > 0) setMapCenter({ AddressLatitude: parseFloat(addressLatitude), AddressLongitude: parseFloat(addresslongitude) })
                const requiredFilterStack = filterStack?.filter(el => el.selection.length > 0)
                setDisplayedRetailLocations(locs =>
                  locs.map(retailLoc => {
                    retailLoc.active =
                      requiredFilterStack?.filter(filterEl => {
                        return retailLoc[filterEl.filteredObjectProperty]?.trim() === filterEl.selection
                      })?.length === requiredFilterStack?.length && (searchValue?.length > 0 ? retailLoc?.searchHash?.includes(searchValue?.toLowerCase()) : true)
                    return retailLoc
                  })
                )
              }}
            >
              {displayedRetailLocations?.map(loc => {
                return <RetailLocationSlim key={loc.CustomerName} {...loc} />
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

const AddressCard = props => {
  const { PhysicalAddress1, PhysicalCity, PhysicalPostcode } = props

  const toTitleCase = str =>
    str.replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
    })
  if (PhysicalAddress1?.trim()?.length < 1) return null
  return (
    <div className="card-text">
      <i className="bi bi-map" />
      <span style={{ paddingLeft: '10px' }} className="card-link">
        {toTitleCase([PhysicalAddress1, PhysicalCity, PhysicalPostcode].filter(a => a).join(', '))}
      </span>
    </div>
  )
}
const RetailLocationSlim = memo(props => {
  const { active, WebsiteURL, CustomerName, FaxNo, AddressLatitude, AddressLongitude, PhoneNo, locationType } = props
  if (!active) return null
  return (
    <div className="g-col-12 ">
      <div className="card h-100 retailLoc" data-addresslatitude={AddressLatitude} data-addresslongitude={AddressLongitude}>
        <div className="card-body">
          <h5 className="card-title text-uppercase">{CustomerName}</h5>
          {locationType && (<h6 className="card-subtitle mb-2 text-muted">{locationType}</h6>)}
          <AddressCard {...props} />

          {!!PhoneNo && (
            <div>
              <i className="bi bi-telephone" />
              <span style={{ paddingLeft: '10px' }}>
                <a href={`tel:${PhoneNo}`} className="card-link">
                  {`${PhoneNo}`}
                </a>
              </span>
            </div>
          )}
          {!!FaxNo && (
            <div title="Fax">
              <i className="bi bi-printer " />
              <span style={{ paddingLeft: '10px' }} className="card-link">
                {FaxNo}
              </span>
            </div>
          )}
          {WebsiteURL.length > 0 && (
            <div title="WebsiteURL">
              <i className="bi bi-globe " />
              <span style={{ paddingLeft: '10px' }}>
                <a href={WebsiteURL} className="card-link" target="_new">
                  {WebsiteURL.replace(/(^\w+:|^)\/\//,"")}
                </a>
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  )
})
const RetailLocation = memo(props => {
  const { active, WebsiteURL, CustomerName, FaxNo, AddressLatitude, AddressLongitude, PhoneNo, locationType } = props
  const { t } = useTranslation()
  if (!active) return null
  return (
    <div className="g-col-12 g-col-md-4">
      <div className="card h-100 retailLoc" data-addresslatitude={AddressLatitude} data-addresslongitude={AddressLongitude}>
        <div className="card-body">
          <h5 className="card-title text-uppercase">{CustomerName}</h5>
          {locationType && (<h6 className="card-subtitle mb-2 text-muted">{locationType}</h6>)}
          <AddressCard {...props} />

          {!!PhoneNo && (
            <div>
              <i className="bi bi-telephone" />
              <span style={{ paddingLeft: '10px' }}>
                <a href={`tel:${PhoneNo}`} className="card-link">
                  {`${PhoneNo}`}
                </a>
              </span>
            </div>
          )}
          {!!FaxNo && (
            <div title="Fax">
              <i className="bi bi-printer " />
              <span style={{ paddingLeft: '10px' }} className="card-link">
                {FaxNo}
              </span>
            </div>
          )}
          {WebsiteURL?.length > 0 && (
            <div title="WebsiteURL">
              <i className="bi bi-globe " />
              <span style={{ paddingLeft: '10px' }}>
                <a href={WebsiteURL} className="card-link" target="_new">
                  {t('frontend.WhereToBuyLocation.website')}
                </a>
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  )
})

const InternalMap = ({ center, zoom, locations }) => {
  const ref = useRef()
  useEffect(() => {
    const map = new window.google.maps.Map(ref.current, {
      center: { lat: center.AddressLatitude, lng: center.AddressLongitude },
      zoom,
    })
    const infoWindow = new window.google.maps.InfoWindow() //static infoWindow for all your markers

    locations.forEach(({ CustomerName, PhysicalAddress1, AddressLatitude, AddressLongitude, PhoneNo }) => {
      let marker = new window.google.maps.Marker({
        position: { lat: AddressLatitude, lng: AddressLongitude },
        map: map,
      })

      if (AddressLatitude === center.AddressLatitude && AddressLongitude === center.AddressLongitude) {
        infoWindow.setContent(`<div><div class="loc-name">${CustomerName}</div> <div>${PhysicalAddress1}</div>  <div>${PhoneNo}</div> </div>`)
        infoWindow.open({
          anchor: marker,
          map,
          shouldFocus: false,
        })
      }

      marker.addListener('click', () => {
        infoWindow.setContent(`<div><div class="loc-name">${CustomerName}</div> <div>${PhysicalAddress1}</div>  <div>${PhoneNo}</div> </div>`)
        infoWindow.open({
          anchor: marker,
          map,
          shouldFocus: false,
        })
      })
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [locations])

  return <div ref={ref} style={{ height: '100%', minHeight: '500px' }} id="map" />
}

const GoogleMap = ({ AddressLatitude, AddressLongitude, locations = [], defaultZoom = 4}) => {
  const theme = useSelector((state) => state.configuration.site.theme);
  const apiKey =  theme.mapsBaseConfig?.apiKey ? theme.mapsBaseConfig?.apiKey : "provide-an-api-key"
  const center =  {
        AddressLatitude : AddressLatitude ? AddressLatitude : theme.mapsBaseConfig?.mapCenter?.addressLatitude, 
        AddressLongitude : AddressLongitude ?  AddressLongitude  :  theme.mapsBaseConfig?.mapCenter?.addressLongitude 
      }
  const zoom = defaultZoom ? defaultZoom : theme.mapsBaseConfig?.zoom

  if(apiKey){
    return (
      <div className="p-1">
        <Wrapper apiKey={apiKey}>
          <InternalMap center={center} 
            locations={locations} 
            zoom={zoom} />
        </Wrapper>
      </div>
    )
  }

}

export { WhereToBuyLocation }